import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { NotificationSettingsDto } from '../../../commonTypes/NotificationTypes/notification.types';

const useHttpGetNotificationSettings = (userSub: string) => {
    const userApi: UserApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<NotificationSettingsDto>();

    const { exec, abort } = userApi.getNotificationSettings({
        params: { userSub },
        onSuccess: res => {
            setData(res.body);
        },
        onError: error => console.error(error),
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { exec, isReady, data };
};

export default useHttpGetNotificationSettings;
